import { render, staticRenderFns } from "./buttonSwitch.vue?vue&type=template&id=4fd4649c&"
import script from "./buttonSwitch.vue?vue&type=script&lang=js&"
export * from "./buttonSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports